import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import type { ManualRoleAudienceRow } from './user-manual-types';

@Component({
  selector: 'app-manual-role-audience-table',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  template: `
    <div class="manual-role-audience">
      <p class="manual-role-audience__title">{{ caption }}</p>
      <div class="manual-role-audience__scroll">
        <table class="manual-role-audience__table">
          <thead>
            <tr>
              <th scope="col">Role</th>
              <th scope="col">Core Functions</th>
              <th scope="col">Ideal For</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row.roleName) {
              <tr>
                <td>
                  <span class="manual-role-audience__role">
                    <strong>{{ row.roleName }}</strong>
                    @if (row.roleQualifier) {
                      <br />
                      <em>({{ row.roleQualifier }})</em>
                    }
                  </span>
                </td>
                <td class="manual-role-audience__core" [innerHTML]="trusted(row.coreHtml)"></td>
                <td>{{ row.idealFor }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  `,
  styleUrl: './manual-role-audience-table.component.scss',
})
export class ManualRoleAudienceTableComponent {
  @Input({ required: true }) rows!: ManualRoleAudienceRow[];
  @Input() caption = 'Intended audience';

  private readonly sanitizer = inject(DomSanitizer);

  trusted(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
